<template>
    <div v-if="isShow" :style="domStyle">
        <img 
        @error="imgLoadError" 
        :src="home_url"  
        :style="picStyle"
        @mousedown="onMouseDown"
        @mouseup="onMouseUp"
        @mousemove="onMouseMove"
        @mouseenter="onMouseEnter"
        @mouseleave="onMouseLeave"
        @dragend="dragEnd"

        >
        <div v-if="isEnable" :style="enableStyle"></div>
    </div>
</template>
<script>
/**
 * 图片精灵，支持动态图片  不支持层级
 */
import Vue from 'vue';
export default {
    name : "fvPicture",
    props : ["primitives","fvSystemApi","parentObject"],
    created(){
        
        this.defaultTailoring = this.parentObject.defaultTailoring;
        this.windowSize = this.parentObject.windowSize;
        //组件数据混淆
        this.mixin(this.primitives);
        // /src/工程名称/img/aa.png
        // this.fvSrc = "src/" + this.$store.state.system.$.projectName +"/"+ this.src.substring(3,this.src.length);
        this.windowsObject = this.$parent.$parent;
        this.workbench = this.windowsObject.workbench;
        //组件大小位置初始化
        this.domStyle = {
            position : "absolute",
            left : 0 + "px",
            top : 0 + "px",
            width : 0 + "px",
            height : 0 + "px",
        }
        this.enableStyle = {
            position: "absolute",
            width: "100%",
            height: "100%",
            top: "0px",
            backgroundColor: "#ccbfbf",
            opacity: "0.5"
        }
        this.picStyle = {
            width : 0 + "px",
            height : 0 + "px",
            border : "none",
            transform : `roate(${this.rotate}deg)`,
            opacity : this.opacity,
            backgroundColor :"transparent"
        }
        this.monitor();
        this.modelsPath = this.parentObject.modelsPath.slice(0);
        this.modelsPath.push(this.registerName);
        this.$store.registerModule(this.modelsPath,{
            state : {
                $ : this
            }
        });
        var fileName = this.fvSystemApi.system.$.getResource(this.fileName);
        if(fileName){
            var arr = this.src.split("/");
            arr[arr.length - 1] = fileName
            this.src = arr.join("/");
        }
        this.home_url = this.src;
        this.originalSize={
            x:this.x,
            y:this.y
        }
        this.initAnimation()
    },
    data(){
        return {
            //是否可用
            isEnable : false,
            //是否显示
            isShow : true,
            //组件大小位置,在created(创建完毕，挂载前)函数中初始化
            domStyle : {},
            picStyle : {},
            //动态控制宽高
            picHeight : "",
            picWidth :"",
            home_url :"",
            // 版本号
            version: "10.0.3.1"
        }
    },
    methods : {
        initAnimation(){
            //周期执行动画对象
            this.preAnimation = {};
            //缓存绘制后动画对象
            this.posAnimation = {};
            //鼠标动画对象
            this.mouseAnimationList = {};
            //绘制前执行动画对象
            this.preAnimationList = {};
            for(var property in this.animation){
                this.picStyle = {cursor: "pointer"}
                //是否具有动画
                this.isAnimation = true;
                var ani = new Vue.prototype[property](this);
                switch(ani.type){
                    case "fvContextMenu":
                    case "fvMessage":
                    case "fvVarInput":
                    case "fvBoolInput":
                    case "fvStringInput":
                    case "fvVerticalDrag":
                    case "fvHorDrag":
                    case "fvLmousescript":
                    case "fvRmousescript":
                    case "fvMousescript":
                    case "fvWindowOpen":
                        this.mouseAnimationList[ani.type] = ani;
                    break;
                    case "fvFlow":
                    case "fvHorFill":
                    case "fvRotateMove":
                    case "fvVerticalFill":
                        this.preAnimationList[ani.type] = ani;
                        this.posAnimation[ani.type] = ani;
                    break;
                    case "fvHide":
                    case "fvForbid":
                    case "fvTwinkel":
                    case "fvVerticalMove":
                    case "fvHorMove":
                        this.preAnimation[ani.type] = ani;
                    break;
                    default:
                        this.preAnimationList[ani.type] = ani;
                    break
                }
            }
        },
        
        /*
        功能:执行动画
        参数:无
        返回值:无
        */
        runAnimation(event, canvas, mouseAnimType){
            //要处理禁止动作//
            if(mouseAnimType == "fvForbid"){
                this.mouseAnimationList[fvForbid].run(event,canvas);
            }
            if(this.mouseAnimationList[mouseAnimType]){
                this.mouseAnimationList[mouseAnimType].run(event,canvas);
            }

        },

        /*
            功能:鼠标按下
            参数:e 属性信息 scaleObj 缩放信息
            返回值:无
        */
        onMouseDown(e){
            switch(e.button){
                case 0://鼠标左键按下
                this.runAnimation(e,this,"fvLmousescript");
                this.runAnimation(e,this,"fvVarInput");
                this.runAnimation(e,this,"fvBoolInput");
                this.runAnimation(e,this,"fvStringInput");
                this.runAnimation(e,this,"fvVerticalDrag");
                this.runAnimation(e,this,"fvHorDrag");
                this.runAnimation(e,this,"fvWindowOpen");
                break;
                case 1:
                    //this.runAnimation(e,this.parent.ctx,MOUSEANIMTYPE_RMOUSE);
                break;
                case 2:
                this.runAnimation(e,this,"fvRmousescript");
                this.runAnimation(e,this,"fvContextMenu");
                break;
                default:
                break;
            }
                
            
        },
        //用于鼠标拖动动画使用释放
        dragEnd(e){
            this.runAnimation(e,this,"fvVerticalDrag");
            this.runAnimation(e,this,"fvHorDrag");
        },
        /*
            功能:鼠标弹起
            参数:e 属性信息 scaleObj 缩放信息
            返回值:无
        */
        onMouseUp(e){
            this.mouseState = true;
            switch(e.button){
                case 0://鼠标左键抬起
                    this.runAnimation(e,this,"fvLmousescript",0);
                    //this.runAnimation(e,this,"fvVerticalDrag");
                    break;
                case 1:
                    break;
                case 2:
                    this.runAnimation(e,this,"fvRmousescript");
                    break;
                default:
                    break;
            }
            //鼠标在图元外抬起时
            this.runAnimation(e,this,"fvVerticalDrag");
            // this.runAnimation(e,this,"fvHorDrag");
            
        },
        /*
            功能:鼠标移动
            参数:e 属性信息 scaleObj 缩放信息
            返回值:无
        */
        onMouseMove(e){
            this.mouseState = true;
            if(this.mouseState){
                this.runAnimation(e,this,"fvVerticalDrag");
                this.runAnimation(e,this,"fvHorDrag");
            }
            this.runAnimation(e,this,"fvMessage");
            this.runAnimation(e,this,"fvMousescript");
        },
        /*
            功能:鼠标进入
            参数:e 属性信息 scaleObj 缩放信息
            返回值:无
        */
        onMouseEnter(e){
            this.mouseState = true;
            if(this.mouseState){
                this.runAnimation(e,this,"fvVerticalDrag");
                this.runAnimation(e,this,"fvHorDrag");
                this.runAnimation(e,this,"fvMessage");
                this.runAnimation(e,this,"fvMousescript");
            }
        },
        /*
            功能:鼠标离开
            参数:e 属性信息 scaleObj 缩放信息
            返回值:无
        */
        onMouseLeave(e){
            this.mouseState = false;
            this.runAnimation(e,this,"fvMessage");
            this.runAnimation(e,this,"fvMousescript");
        },
        /*
            参数：无
            作用：系统周期调用
        */
        onTimer(){
            // console.log(23)
            if(this.disableFlag){
                return;
            }
            if(this){
                for(var p in this.preAnimation){
                    this.preAnimation[p].run(this,true);
                }
            }
            //一般性动作
            for(var p in this.preAnimationList){
                this.preAnimationList[p].run(this,true)
            }
        },
        /*
            参数：scaleObj 重绘信息
            作用：组件需要重绘时触发
        */
        reDraw(scaleObj){
            var fileName = this.fvSystemApi.system.$.getResource(this.fileName);
            if(fileName){
                var arr = this.src.split("/");
                arr[arr.length - 1] = fileName
                this.src = arr.join("/");
            }
            this.home_url = this.src;
            if(this.fontSize){
                this.domStyle.fontSize = parseInt(parseInt(this.fontSize.substr(0, this.fontSize.length - 2)) * (scaleObj.sy + scaleObj.zoom) + scaleObj.oy) + "px"; 
            };
            if(scaleObj.titleHeight != 0){
                var titleHeight = 0;
            }else{
                var titleHeight = this.y * this.frameScaleY;
            }
            this.domStyle.left = parseInt((this.x * (scaleObj.sx + scaleObj.zoom)) + scaleObj.ox) + "px";
            this.domStyle.top = parseInt(((this.y )* (scaleObj.sy + scaleObj.zoom)) + scaleObj.oy) + "px";
            this.domStyle.width = parseInt(this.width * (scaleObj.sx + scaleObj.zoom)) + "px";
            this.domStyle.height = parseInt(this.height * (scaleObj.sy + scaleObj.zoom)) + "px"; 
            this.picHeight = Math.round(this.height * (scaleObj.sy + scaleObj.zoom)) + "px"; 
            this.picWidth  = Math.round(this.width * (scaleObj.sx + scaleObj.zoom)) + "px";
            this.picStyle.height = this.picHeight;
            this.picStyle.width = this.picWidth;
            
        },
        /*
            参数：isShow 显示隐藏
            作用：设置组件整体显隐
        */
        Show(isShow){
            this.isShow = isShow ? true : false;
        },
        /*
            参数：isEnable 是否可用
            作用：设置组件是否可用
        */
        Enable(isEnable){
            this.enableStyle.transform=this.picStyle.transform;
            this.isEnable = isEnable ? false : true;
        },
        /*
            参数：src ：外部属性（对象）
            作用：混淆属性
        */
        mixin(src) {
            for (var key in src) {
                this[key] = src[key]
            }
        },
        /*
            参数：无
            作用：监听组件内部属性
        */
        monitor(){
            //监听是否为图片增加边框
            Object.defineProperty(this,"Border",{
                set(value){
                    if(value == 0){
                        this.picStyle.border = "none";
                    }else{
                        this.picStyle.border = `${this.borderWidth}px solid ${this.borderColor}`;
                    }
                    this.$forceUpdate();
                },
                get(){
                    return this.picStyle.border
                }
            });
            //监听图片边框宽度
            Object.defineProperty(this,"LineWidth",{
                set(value){
                    if(this.picStyle.border == "none"){
                        this.borderWidth = value;
                    }else{
                        this.borderWidth = value;
                        this.picStyle.border = `${value}px solid ${this.borderColor}`
                        this.$forceUpdate();
                    }
                },
                get(){
                    return this.picStyle.border
                }
            })
            //监听图片精灵文件读取路径
            Object.defineProperty(this,"Path",{
                set(value){
                    this.home_url = `src/New App1/img/${value}`;
                    this.$forceUpdate();
                },
                get(){
                    return this.home_url;
                }
            })
            //监听旋转角度
            Object.defineProperty(this,"Rotate",{
                set(value){
                    this.picStyle.transform = `rotate(${value}deg)`;
                    if(this.isEnable){
                         this.enableStyle.transform=`rotate(${value}deg)`;
                    }
                    this.$forceUpdate();
                },
                get(){
                    return this.picStyle.transform;
                }
            })
            //监听透明度
            Object.defineProperty(this,"Transparency",{
                set(value){
                    var num = Number(value / 255)
                    this.picStyle.opacity = num;
                    this.$forceUpdate();
                },
                get(){
                    return this.picStyle.opacity;
                }
            })
            //监听背景色
            Object.defineProperty(this,"TransparencyBackColor",{
                set(value){
                    this.picStyle.backgroundColor = value;
                    this.$forceUpdate();
                },
                get(){
                    return this.picStyle.backgroundColor;
                }
            })
        },

        imgLoadError(){
            this.$nextTick(() => {
                this.home_url = require('../../../assets/errPic.jpg');
            })
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/components/primitives/fvPicture/fvPicture.vue